export default __webpack_public_path__ + "./images/noPhoto100.43b14c3c.svg";